import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";
import ResultModalWindow from "../../../components/AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow.jsx";

import {
  setSearchParamsBoats,
  setPageIndexBoats,
} from "../../../redux/smallBoatsReducer/actionsSmallBoats.js";

import { SMALLBOATS_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";
import { options } from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";

import { getDataBoatsBySearchParams } from "../../../redux/actions.js";

import styles from "./SmallBoats.module.css";

export default function SmallBoats() {
  const dispatch = useDispatch();

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [show, setShow] = useState(false);
  const [showResultModal, setShowResultWindow] = useState(false);
  const [propsForButtons, setPropsForButtons] = useState({
    disabledButtonPrint: true,
  });
  const [licenseData, setLicenseData] = useState({});
  const [searchParams, setSearchParams] = useState({
    ownerSurname: "",
    ownerName: "",
    ownerMidname: "",
    regNum: "",
    leName: "",
    leUnp: "",
    boatVin: "",
    engvin: "",
    cardStatusCode: 1,
  });

  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });

  const dataFromState = useSelector((state) => {
    const { smallBoatsReducer } = state;
    return smallBoatsReducer.paginationData;
  });

  const searchParamsFromState = useSelector((state) => {
    const { smallBoatsReducer } = state;
    return smallBoatsReducer.searchParams;
  });

  const pageIndexFromState = useSelector((state) => {
    const { smallBoatsReducer } = state;
    return smallBoatsReducer.pageIndex;
  });

  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.SMALL_BOATS?.viewTheRcOfASmallVessel?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(
    sortedMenuNames?.SMALL_BOATS?.editingTheRcOfASmallVessel?.chapterActionId,
  );

  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        ownerSurname: "",
        ownerName: "",
        ownerMidname: "",
        regNum: "",
        leName: "",
        leUnp: "",
        boatVin: "",
        engvin: "",
        cardStatusCode: 1,
      }),
    );
    dispatch(
      getDataBoatsBySearchParams(
        {
          ownerSurname: "",
          ownerName: "",
          ownerMidname: "",
          regNum: "",
          leName: "",
          leUnp: "",
          boatVin: "",
          engvin: "",
          cardStatusCode: 1,
        },
        0,
      ),
    );
    dispatch(
      setSearchParamsBoats({
        ownerSurname: "",
        ownerName: "",
        ownerMidname: "",
        regNum: "",
        leName: "",
        leUnp: "",
        boatVin: "",
        engvin: "",
        cardStatusCode: 1,
      }),
    );
    dispatch(setPageIndexBoats(0));
    setPropsForButtons({ disabledButtonPrint: true });
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };
  const handleSearch = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setPropsForButtons({ disabledButtonPrint: true });
    dispatch(getDataBoatsBySearchParams(searchParams, 0));
    dispatch(setSearchParamsBoats({ ...searchParams }));
    dispatch(setPageIndexBoats(0));
  };

  const handleSearchLicense = (data) => {
    setLicenseData(data);
    setShowResultWindow(true);
  };

  const handleRowSelect = (rowData) => {
    setSelectedRowData(rowData);
    setPropsForButtons({ disabledButtonPrint: false });
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
    dispatch(setPageIndexBoats(pageIndex));
    setPropsForButtons({ disabledButtonPrint: true });
  };

  useMemo(() => {
    setPropsForButtons({ disabledButtonPrint: true });
    setSearchParams({ ...searchParamsFromState });
    setSelectedPage(pageIndexFromState);
  }, []);

  useEffect(() => {
    setSelectedRowData(null);
    dispatch(getDataBoatsBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  const createMessage = () => {
    return (
      !!licenseData && (
        <>
          <div className={styles["license-name-photo-block"]}>
            {licenseData?.fotoId && (
              <img
                src={`https://gims-dev.compit.by:8080/boats/file/download/attachment/${licenseData?.fotoId}`}
                className={styles["license-img"]}
                alt="Photo"></img>
            )}
            <div className={styles["license-name-block"]}>
              <p className={`${styles["license-text"]} ${styles["italic"]}`}>{licenseData?.fioRu}</p>
              <p className={`${styles["license-text"]} ${styles["italic"]}`}>{licenseData?.fioEng}</p>
            </div>
          </div>
          <p className={styles["license-text"]}>
            {"Отметки о лишении права управления: "}
            <span className={styles["license-value-text"]}>{licenseData?.boatDrivingLicenseConfDepriv}</span>
          </p>
          <p className={styles["license-text"]}>
            {"Отметки об изъятии: "}
            <span className={styles["license-value-text"]}>{licenseData?.boatDrivingLicenseConfSeiz}</span>
          </p>
          <p className={styles["license-text"]}>
            {"Медицинские показания: "}
            <span className={styles["license-value-text"]}>{licenseData?.medConditions}</span>
          </p>
          {licenseData?.validFor && (
            <p className={styles["license-text"]}>
              {"Действительно для: "}
              <span className={styles["license-value-text"]}>{licenseData?.validFor}</span>
            </p>
          )}
        </>
      )
    );
  };

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsSmallBoats}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        id={selectedRowData?.cardid}
        show={show}
        setShow={setShow}
        editAccess={editAccess}
        viewAccess={viewAccess}
        propsForButtons={propsForButtons}
        handleData={handleSearchLicense}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={SMALLBOATS_COLUMNS}
        data={dataFromState.content || []}
        totalPages={dataFromState.totalPages || 0}
        totalElements={dataFromState.totalElements || 0}
        selectedPage={selectedPage}
      />
      {showResultModal && (
        <ResultModalWindow
          show={showResultModal}
          setShow={setShowResultWindow}
          headerTextExternal={licenseData.license || licenseData.message || "Произошла ошибка"}
          externalJSX={licenseData?.fioRu && createMessage()}
          errorText={licenseData?.invalidRequest && "Ошибка поиска. Повторите попытку позже."}
        />
      )}
    </div>
  );
}
